const filterInit = () => {
  const archiveFitlers = document.querySelectorAll('.archive-filter') as NodeListOf<HTMLElement>;
  const showFilters = document.querySelectorAll('.show-filters') as NodeListOf<HTMLElement>;

  const toggleFilter = () => {
    [...archiveFitlers].forEach((archiveFitler) => {
      const filterEle = archiveFitler;
      filterEle.classList.toggle('archive-filter--active');
    });
  };

  [...archiveFitlers].forEach((archiveFilter) => {
    const filterButton = archiveFilter.querySelector('.filter-button') as HTMLButtonElement;

    filterButton.addEventListener('click', () => {
      const parent = filterButton.closest('.archive-filter') as HTMLElement;
      const inner = parent.querySelector('.archive-option-filter') as HTMLElement;
      const applyFilter = inner.querySelector('.apply-filters') as HTMLButtonElement;
      filterButton.classList.add('archive-filter__button--active');

      setTimeout(() => {
        applyFilter.click();
      }, 300);
    });
  });

  [...showFilters].forEach((filter) => {
    filter.addEventListener('click', () => {
      toggleFilter();
    });
  });

  // filter backbutton
  const backButton: HTMLElement = document.querySelector('.backbutton');

  backButton.addEventListener('click', () => {
    toggleFilter();
  });
};

export default filterInit;
